module.exports = __webpack_public_path__ + "static/powered-by-pldt-b07f27492785d0f60f0181641a99625f.png";